import type { CreditedConsumerTermsConfig } from '#types/config/components/dialog/creditedConsumerTerms'
import type { RecursivePartial } from '#types/utils'

export default {
  declineButtonVariant: 'tertiary',
} satisfies RecursivePartial<CreditedConsumerTermsConfig>
